import * as $ from "jquery";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  CommonModule,
  LocationStrategy,
  HashLocationStrategy,
} from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { Routes, RouterModule } from "@angular/router";

import { FullComponent } from "./layouts/full/full.component";
import { BlankComponent } from "./layouts/blank/blank.component";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";

import { NavigationComponent } from "./shared/header-navigation/navigation.component";
import { SidebarComponent } from "./shared/sidebar/sidebar.component";
import { SidebarIconComponent } from "./shared/sidebar/sidebar-icon.component";
import { BreadcrumbComponent } from "./shared/breadcrumb/breadcrumb.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SpinnerComponent } from "./shared/spinner.component";
import { NotifierModule } from "angular-notifier";
import { UtilsModule } from "./utils/utils.module";
import { ReqInterceptor } from "./interceptors/req.interceptor";
import { SeteosEmpresarialesComponent } from "./mantenimiento/seteos-empresariales/seteos-empresariales.component";
import { NgxPrintModule } from "ngx-print";
import { SpinnerOverlayComponent } from "./shared/spinner-overlay/spinner-overlay.component";
import { MantenimientoPlataformaComponent } from "./shared/mantenimiento-plataforma/mantenimiento-plataforma.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { SpinnerInterceptor } from "./interceptors/loading.interceptor";
import { OverlayModule } from "@angular/cdk/overlay";
import { AvisoPlataformaModule } from "./shared/aviso-plataforma/aviso-plataforma.module";
import { NovedadesPlataformaModule } from "./shared/novedades-plataforma/novedades-plataforma.module";
import { NotificacionesFlotantesComponent } from "./shared/notificaciones-flotantes/notificaciones-flotantes.component";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true,
};

@NgModule({
  declarations: [
    AppComponent,
    SpinnerComponent,
    FullComponent,
    BlankComponent,
    NavigationComponent,
    BreadcrumbComponent,
    SidebarComponent,
    SidebarIconComponent,
    SpinnerOverlayComponent,
    MantenimientoPlataformaComponent,
    NotificacionesFlotantesComponent,
  ],
  imports: [
    NgxPrintModule,
    CommonModule,
    OverlayModule,
    AvisoPlataformaModule,
    NovedadesPlataformaModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
    MatProgressSpinnerModule,
    NgMultiSelectDropDownModule.forRoot(),
    PerfectScrollbarModule,
    AppRoutingModule,

    NotifierModule.withConfig({
      theme: "material",
      position: {
        horizontal: {
          position: "right",
          distance: 12,
        },
        vertical: {
          position: "bottom",
          distance: 12,
          gap: 10,
        },
      },
      behaviour: {
        autoHide: 4200,
        onMouseover: "pauseAutoHide",
        showDismissButton: true,
        stacking: 4,
      },
      animations: {
        enabled: true,
        show: {
          speed: 220,
          easing: "ease-out",
        },
        hide: {
          speed: 180,
          easing: "ease-in",
        },
        shift: {
          speed: 180,
          easing: "ease-out",
        },
      },
    }),

    UtilsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ReqInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true,
    },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
